import { render, staticRenderFns } from "./attachmentList.vue?vue&type=template&id=d1e0084c&scoped=true"
import script from "./attachmentList.vue?vue&type=script&lang=js"
export * from "./attachmentList.vue?vue&type=script&lang=js"
import style0 from "./attachmentList.vue?vue&type=style&index=0&id=d1e0084c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e0084c",
  null
  
)

export default component.exports